import type { IconProps } from "@tamagui/helpers-icon";
import * as React from "react";
import { Svg, Line } from "react-native-svg";

export function AlertBasic(props: IconProps) {
  const { color = "black", size = 24, ...otherProps } = props;
  return (
    <Svg
      width={size as number}
      height={size as number}
      viewBox="0 0 24 24"
      fill="none"
      // eslint-disable-next-line typescript-eslint/no-base-to-string, typescript-eslint/restrict-template-expressions
      stroke={`${color}`}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(otherProps as object)}
    >
      <Line
        x1="12"
        y1="5"
        x2="12"
        y2="13"
        fill="none"
        // eslint-disable-next-line typescript-eslint/no-base-to-string, typescript-eslint/restrict-template-expressions
        stroke={`${color}`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Line
        x1="12"
        y1="17"
        x2="12"
        y2="19"
        fill="none"
        // eslint-disable-next-line typescript-eslint/no-base-to-string, typescript-eslint/restrict-template-expressions
        stroke={`${color}`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
export default AlertBasic;
